import React, { useState, useEffect } from "react";
import { Row, Col } from "reactstrap";

import { connect } from "react-redux";
import {
  searchPharmacies,
  setPage,
  resetReducer
} from "../../redux/actions/pharmacies";

import Searcher from "./Searcher";
import Loader from "../ListLoading";
import Maps from "../Maps";
import Paginator from "../Paginator";
import Container from "./Container";
import PageWrapper from "../PageWrapper";

const Content = ({
  searchPharmacies,
  loading,
  markers,
  setPage,
  resetReducer,
  links,
  meta,
  filters
}) => {
  const [fetchData, setFetchData] = useState(false);

  const defaultPosition = {
    center: {
      lat: -34.6036844,
      lng: -58.381559100000004
    },
    zoom: 11
  };

  const handlePaginator = async page => {
    setPage(page);
    setFetchData(true);
  };

  useEffect(() => {
    return () => resetReducer();
  }, [resetReducer]);


  useEffect(() => {
    console.log('fetchData:');
    console.log(fetchData);
    console.log('filters:');
    console.log(filters);
    
    // if (fetchData) {
    searchPharmacies(filters);
    // setFetchData(false);
    // }
  }, [fetchData, filters, searchPharmacies]);

  return (
    <PageWrapper>
      <Searcher />
      <Row className="w-100">
        <Col xs={12} sm={6}>
          <span className="d-block mb-4">
            Resultado de búsqueda: <span>busqueda...</span>{" "}
          </span>
          {loading ? (
            <>
              <Loader />
            </>
          ) : (
            <>
              <Container />
            </>
          )}

          {markers.length > 0 && (
            <Paginator
              handlePaginator={handlePaginator}
              loading={loading}
              currentPage={meta.currentPage}
              first={links.first}
              last={links.last}
              next={links.next}
              prev={links.prev}
              center={true}
            />
          )}
        </Col>
        <Col xs={12} sm={6}>
          <Maps
            center={defaultPosition.center}
            zoom={defaultPosition.zoom}
            markers={markers}
          />
        </Col>
      </Row>
    </PageWrapper>
  );
};

const mapStateToProps = state => ({
  loading: state.pharmacies.loading,
  markers: state.pharmacies.markers,

  links: state.pharmacies.links,
  meta: state.pharmacies.meta,
  filters: state.pharmacies.filters
});

export default connect(mapStateToProps, {
  searchPharmacies,
  setPage,
  resetReducer
})(Content);
